// ============================================================================
// CANCUN100 — CuponDocs.js  (APP 2/32c · Documentos: «Ver» directo y «Descargar» de las dos versiones del cupón)
// ----------------------------------------------------------------------------
// Para un folio que YA existe (Mis ventas → Documentos, versiones .1/.2, cambios, abonos): al abrir se piden las ligas
// firmadas y «Ver» es un enlace normal a pestaña nueva (sin pestaña en blanco ni pasos intermedios); «Descargar» al lado.
// Nueva versión = cupón 2.0 (<carpeta>-v2/<folio>.pdf); versión anterior = la ruta de siempre (pdf_supabase_cliente).
// Si el folio no tiene todavía el cupón 2.0 (hecho antes), «Crear nueva versión» lo genera y lo guarda.
// APP 2/32d: «Rehacer» vuelve a generar el 2.0 encima (p. ej. AS-1161 con el logo oficial); la versión que se manda no se toca.
// ============================================================================
import React, { useCallback, useEffect, useState } from 'react';
import { Ic } from './iconos';
import { MOSTRAR_VERSION_ANTERIOR, CUPON_ENVIO, BUCKET_CLIENTE, rutaV2, nombreArchivo } from './pdf/versionesCupon';
import { generarV2DesdeReserva } from './pdf/pdfUploader';

const firmar = async (supabase, ruta, nombre) => {
  if (!ruta) return null;
  try {
    const [ver, bajar] = await Promise.all([
      supabase.storage.from(BUCKET_CLIENTE).createSignedUrl(ruta, 3600),
      supabase.storage.from(BUCKET_CLIENTE).createSignedUrl(ruta, 3600, { download: nombre }),
    ]);
    if (ver.error || !ver.data?.signedUrl) return null;
    return { ver: ver.data.signedUrl, bajar: bajar.data?.signedUrl || ver.data.signedUrl };
  } catch (e) { return null; }
};

export default function CuponDocs({ supabase, r, proveedores = [], compacto = false }) {
  const tipo = r?.tipo === 'cotizacion' ? 'cotizacion' : 'reserva';
  const folio = r?.folio || r?.folio_personalizado;
  const cliente = r?.nombre || r?.cliente || '';
  const [ligas, setLigas] = useState({ cargando: true, nueva: null, anterior: null });
  const [creando, setCreando] = useState(false); const [err, setErr] = useState('');
  const cargar = useCallback(async () => {
    if (!folio) { setLigas({ cargando: false, nueva: null, anterior: null }); return; }
    const principal = r?.pdf_supabase_cliente || null;
    const [nueva, enRuta] = await Promise.all([firmar(supabase, rutaV2(tipo, folio), nombreArchivo(folio, cliente)), firmar(supabase, principal, nombreArchivo(folio, cliente, CUPON_ENVIO === 'anterior' ? ' (versión anterior)' : ''))]);
    setLigas({ cargando: false, nueva: nueva || (CUPON_ENVIO === 'nueva' ? enRuta : null), anterior: CUPON_ENVIO === 'anterior' ? enRuta : null });
  }, [supabase, folio, tipo, cliente, r?.pdf_supabase_cliente]);
  useEffect(() => { cargar(); }, [cargar]);
  const crear = async () => { setCreando(true); setErr(''); try { await generarV2DesdeReserva({ supabase, reservaId: r.id, proveedores }); await cargar(); } catch (e) { setErr(e.message || String(e)); } finally { setCreando(false); } };
  const fila = (titulo, l, principal) => (
    <span className={`cd-fila${principal ? ' cd-principal' : ''}`}>
      <span className="cd-t">{titulo}</span>
      {l ? <><a className={principal ? 'gl-btn' : 'gl-lnk'} href={l.ver} target="_blank" rel="noopener noreferrer"><Ic n="Eye" chico /> Ver</a><a className="gl-lnk cd-bajar" href={l.bajar} download><Ic n="Download" chico /> Descargar</a></>
        : ligas.cargando ? <span className="gl-nota">…</span> : null}
    </span>
  );
  if (!folio) return null;
  return (
    <span className={`cd${compacto ? ' cd--compacto' : ''}`}>
      {ligas.nueva ? <>{fila(compacto ? 'Nueva' : 'Cupón · nueva versión', ligas.nueva, true)}{r?.id != null && <button type="button" className="gl-lnk" disabled={creando} onClick={crear} title="Vuelve a generar el cupón 2.0 con los datos guardados (no toca la versión que se manda)"><Ic n="RefreshCw" chico /> {creando ? 'Rehaciendo…' : 'Rehacer'}</button>}</>
        : !ligas.cargando && <span className="cd-fila cd-principal"><span className="cd-t">{compacto ? 'Nueva' : 'Cupón · nueva versión'}</span><button type="button" className="gl-btn" disabled={creando || r?.id == null} onClick={crear}><Ic n="FilePlus2" chico /> {creando ? 'Creando…' : 'Crear nueva versión'}</button></span>}
      {MOSTRAR_VERSION_ANTERIOR && (ligas.anterior || ligas.cargando) && fila(compacto ? 'Anterior' : 'Versión anterior', ligas.anterior, false)}
      {err && <span className="gl-nota" style={{ color: 'var(--au-error-fg)' }}>{err}</span>}
    </span>
  );
}
